var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center items-center w-full h-full text-primary flex-col",staticStyle:{"font-size":"56px"}},[_c('AppLoading'),(_vm.$slots.default)?_c('span',{staticClass:"type-scale-3 text-gray-80 pt-4"},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }